import { render, staticRenderFns } from "./LikertScaleAvaliationItemStrategy.vue?vue&type=template&id=1ebb03da"
import script from "./LikertScaleAvaliationItemStrategy.vue?vue&type=script&lang=js"
export * from "./LikertScaleAvaliationItemStrategy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports